import { Button, Form } from 'antd';
import React, { useState } from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Debug from 'components/Debug';
import Email from 'components/forms/Email';
import Toast from 'components/Toast';
import VerifyCodeSend from 'components/VerifyCodeSend';
import security from 'stores/security';
import store from '../../store';

const EmailChangeModule: React.FC = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const $formutil = useForm();

    const submit = async () => {
        const { $params, $invalid, $getFirstError, $batchDirty } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            setLoading(true);

            try {
                const params = {
                    ...$params,
                    verify_token: (location.state as any)?.verify_token || ''
                };

                await store.modifySetting('email', params);

                await security.getStatus();

                navigate(location.pathname.replace('3', '4'));
            } catch (err) {
                Toast.show(err);

                // 操作时长过长，重新回到第一步
                if (err.error_code === 11804) {
                    navigate('/profile/security/modify/email');
                }
            }

            setLoading(false);
        }
    };

    const { $params, $errors } = $formutil;

    if (!location?.state) {
        return <Navigate to="../1" replace />;
    }

    return (
        <Form onFinish={submit} layout="vertical">
            <Email name="email" line placeholder={__('请输入邮箱')} />
            <VerifyCodeSend type="email" process="modify_email" username={$errors.email ? '' : $params.email} />
            <CardButtonWrap>
                <Button
                    block
                    type="primary"
                    size="large"
                    className="verify-identify-btn"
                    loading={loading}
                    disabled={!$params.verify_code}
                    htmlType="submit">
                    {__('下一步')}
                </Button>
            </CardButtonWrap>
            <Debug data={$params} />
        </Form>
    );
};

export default withForm(EmailChangeModule);
